// Currency conversion shared by the server and the browser. Rates are "euros per one unit" so any pair converts
// through the euro.

export interface RateTable {
  /** Euros per one unit of each currency. */
  rates: Record<string, number>;
  updatedAt: string | null;
  source: string;
}

/** Converts an amount between currencies. Unknown currencies convert at 1:1 so totals never break. */
export function convertWith(rates: Record<string, number>, amount: number, from: string, to: string): number {
  if (from === to) return amount;
  const fromEur = rates[from] ?? 1;
  const toEur = rates[to] ?? 1;
  return (amount * fromEur) / toEur;
}
